import { render, staticRenderFns } from "./ImportKvkModal.vue?vue&type=template&id=cedf2b62&scoped=true&"
import script from "./ImportKvkModal.vue?vue&type=script&lang=js&"
export * from "./ImportKvkModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportKvkModal.vue?vue&type=style&index=0&id=cedf2b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedf2b62",
  null
  
)

export default component.exports